import { render } from "./ExpedientDetailShowMedia.vue?vue&type=template&id=e156ef7c"
import script from "./ExpedientDetailShowMedia.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailShowMedia.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__